import styled from 'react-emotion';
import { get } from '@utils/theme';
export const Hr = styled('hr') `
  border: none;
  border-top: 1px dashed ${get('colors.border')};

  ${p => p.theme.docz.mq({
    margin: ['30px 0', '50px 0'],
})};

  ${p => p.theme.docz.mq(p.theme.docz.styles.hr)};
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSHIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY29tcG9uZW50cy91aS9Ici50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0sZUFBZSxDQUFBO0FBQ2xDLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxjQUFjLENBQUE7QUFFbEMsTUFBTSxDQUFDLE1BQU0sRUFBRSxHQUFHLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQTs7MkJBRUgsR0FBRyxDQUFDLGVBQWUsQ0FBQzs7SUFFM0MsQ0FBQyxDQUFDLEVBQUUsQ0FDSixDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUM7SUFDZCxNQUFNLEVBQUUsQ0FBQyxRQUFRLEVBQUUsUUFBUSxDQUFDO0NBQzdCLENBQUM7O0lBRUYsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLEVBQUUsQ0FBQztDQUMvQyxDQUFBIn0=